// Auto-generated by scripts/generate-version-json.js — do not edit manually.
export const APP_VERSION = "3.6";
export const APP_BUILD_TIME = "2026-08-15T00:30:15.366Z";
